import ApolloClient from 'apollo-client';

import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink, split } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { withClientState } from 'apollo-link-state';
import urlCheck from '../utils/urlCheck';
import config from '../config';

const createClient = () => {
    const endpointDomain = config('apiDomain');
    const authMiddleware = new ApolloLink((operation, forward) => {
        operation.setContext({
            headers: {
                'X-TRP-Requested-With': urlCheck('mock')
                    ? 'localGraphQL'
                    : 'XMLHttpRequest',
                apikey: config('apiKey')
            }
        });
        return forward(operation);
    });

    const usingMock = urlCheck('mock');
    const host = (() => {
        if (usingMock) {
            return `${window.location.protocol}//${
                window.location.hostname
            }:33000`;
        }
        return endpointDomain;
    })();

    // @todo APIS should have same path
    const path = `/investment-vehicle${
        !usingMock ? '-svc' : ''
    }/service/graphql`;

    const uri = `${host}${path}`;

    const batchLink = new BatchHttpLink({
        uri: `${uri}-batch`
    });
    const httpLink = new HttpLink({ uri });

    const cache = new InMemoryCache();

    const stateLink = withClientState({
        cache
    });

    return new ApolloClient({
        link: split(
            (operation) => operation.getContext().unbatch === true,
            ApolloLink.from([stateLink, authMiddleware, httpLink]),
            ApolloLink.from([stateLink, authMiddleware, batchLink])
        ),
        cache
    });
};

export default createClient;



// WEBPACK FOOTER //
// ./src/graphql/clientSetup.js